import { login, getUserInfo, logout } from '@/services/api';
import { setUser } from '@/services/user';
import { useWebSocket }  from '@/const/webSocket';
const AUTH_TOKEN_KEY = 'auth_token';

let authToken = localStorage.getItem(AUTH_TOKEN_KEY);

const persistenceAuthToken = (token) => {
    try {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    } catch (e) {
        // ignore
    }
};

const setAuthToken = (token) => {
    authToken = token;
    persistenceAuthToken(token);
};

const clearAuthToken = () => {
    authToken = '';
    try {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    } catch (e) {
        // ignore;
    }
};

export async function userInfoService() {
    const resp = await getUserInfo();

    if (resp.code !== 200) {
        throw new Error('get userinfo failed');
    }

    setUser(resp.data);
}

export async function loginService(username, password) {
    try {
        const resp = await login({
          username,
          password
        });
        if (resp.code !== 200) {
            // 用户名或密码错误
            throw resp.message.replace('[D1000] ', '').replace('[D0001] ', '');
        }
        // JWT认证token：优先从响应头 Access-Token 取，其次从响应体 data 取
        const token = resp.__accessToken || resp.data;
        setAuthToken(token);

        // 获取用户信息
        await userInfoService();
        return resp
    } catch (e) {
        throw e;
    }
}

export async function logoutService() {
    try {
        const resp = await logout();
        if (resp.code !== 204) {
            // 用户名或密码错误
            throw new Error('logout failed');
        }
        // 清除JWT认证token
        clearAuthToken();
    } catch (e) {
        throw e;
    }
}

export const getAuthToken = () => authToken;
